export * from './merge-shelf-bin.component';
export * from './view-merge-bin.component';
export * from './merge-modal.component';